import { DeleteOutlined, ReloadOutlined } from "@ant-design/icons";
import { Popconfirm, Row, Col, Space, Tag, message } from "antd";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import React, { Component } from "react";
import { connect } from "react-redux";
import { ModalItem, ButtonItem, TableItem } from "../../../../Components/Items";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";

moment.locale("es");

class InformacionRelojChecador extends Component {
    pollTimer = null;
    state = {
        loading: false,
        data: null,
        usuariosDispositivo: [],
        asignaciones: [],
        emparejarPin: null,
        emparejarEmpleadoId: null,
    };

    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible) {
            this.cargarDatos();
            this.iniciarPolling();
        }
        if (this.props.visible !== prevProps.visible && !this.props.visible) {
            this.detenerPolling();
        }
    }

    componentWillUnmount() {
        this.detenerPolling();
    }

    iniciarPolling() {
        this.detenerPolling();
        this.pollTimer = setInterval(() => this.cargarDatos(true), 5000);
    }

    detenerPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }

    cargarDatos(silencioso) {
        if (!silencioso) this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/datosRelojChecador",
                { empresaId: this.props.empresaId, relojChecadorId: this.props.relojChecadorId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (!silencioso) this.setState({ loading: false });
                if (res.data.success === 2) {
                    this.setState({
                        data: res.data.data,
                        usuariosDispositivo: res.data.usuariosDispositivo || [],
                        asignaciones: res.data.asignaciones || [],
                    });
                }
            });
    }

    actualizarAhora() {
        this.setState({ loading: true });
        axios
            .post(
                "relojesChecadores/consultarInformacionRelojChecador",
                { empresaId: this.props.empresaId, relojChecadorId: this.props.relojChecadorId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Se solicitó al reloj su información");
                } else {
                    message.error(res.data.message || "No se pudo consultar el reloj");
                }
                this.cargarDatos();
            });
    }

    eliminarDelReloj(pin) {
        axios
            .post(
                "relojesChecadores/eliminarUsuarioSoloDeReloj",
                { empresaId: this.props.empresaId, relojChecadorId: this.props.relojChecadorId, pin },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Se solicitó eliminar el usuario del reloj");
                    this.setState((prev) => ({
                        usuariosDispositivo: prev.usuariosDispositivo.filter((u) => u.pin !== pin),
                    }));
                } else {
                    message.error(res.data.message || "No se pudo eliminar el usuario del reloj");
                }
            });
    }

    eliminarDelSistema(asignacionRelojId) {
        axios
            .post(
                "asignacionesRelojes/deshabilitarAsignacionReloj",
                { empresaId: this.props.empresaId, asignacionRelojId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Se eliminó la asignación del sistema");
                    this.cargarDatos();
                } else {
                    message.error(res.data.message || "No se pudo eliminar la asignación");
                }
            });
    }

    emparejar(pin) {
        if (!this.state.emparejarEmpleadoId) {
            message.error("Selecciona un empleado");
            return;
        }
        axios
            .post(
                "asignacionesRelojes/agregarAsignacionReloj",
                {
                    empresaId: this.props.empresaId,
                    relojChecadorId: this.props.relojChecadorId,
                    usuarioRelojChecador: pin,
                    empleadoId: this.state.emparejarEmpleadoId,
                },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    message.success("Se emparejó el usuario con el empleado");
                    this.setState({ emparejarPin: null, emparejarEmpleadoId: null });
                    this.cargarDatos();
                } else {
                    message.error(res.data.message || "No se pudo emparejar el usuario");
                }
            });
    }

    cerrar() {
        this.detenerPolling();
        this.setState({
            data: null,
            usuariosDispositivo: [],
            asignaciones: [],
            emparejarPin: null,
            emparejarEmpleadoId: null,
        });
        this.props.cerrarInformacionRelojChecador();
    }

    render() {
        const { data, usuariosDispositivo, asignaciones } = this.state;

        const solicitadoAt = data?.usuariosDispositivoSolicitadoAt;
        const actualizadoAt = data?.usuariosDispositivoActualizadoAt;
        const esperandoRespuesta =
            !!solicitadoAt && (!actualizadoAt || moment(actualizadoAt).isBefore(moment(solicitadoAt)));

        const tagSiNo = (value) =>
            value ? <Tag color="green">Sí</Tag> : <Tag color="default">No</Tag>;

        const columnasDispositivo = [
            { title: "PIN", dataIndex: "pin", key: "pin", width: 70 },
            { title: "Nombre (reloj)", dataIndex: "nombre", key: "nombre" },
            { title: "Huella", dataIndex: "tieneHuella", key: "tieneHuella", align: "center", width: 80, render: tagSiNo },
            { title: "Rostro", dataIndex: "tieneRostro", key: "tieneRostro", align: "center", width: 80, render: tagSiNo },
            {
                title: "Estado",
                key: "estado",
                width: 140,
                render: (_, record) => {
                    const enSistema = asignaciones.some((a) => a.usuarioRelojChecador === record.pin);
                    return enSistema
                        ? <Tag color="green">En el sistema</Tag>
                        : <Tag color="orange">Sin asignar</Tag>;
                },
            },
            {
                title: "Acción",
                key: "accion",
                width: 220,
                render: (_, record) => {
                    const asignado = asignaciones.some((a) => a.usuarioRelojChecador === record.pin);
                    return (
                        <Space>
                            {!asignado && (
                                this.state.emparejarPin === record.pin ? (
                                    <Space>
                                        <SelectEmpleadosItem
                                            empresaId={this.props.empresaId}
                                            headersToken={this.props.headersToken}
                                            value={this.state.emparejarEmpleadoId}
                                            onChange={(value) => this.setState({ emparejarEmpleadoId: value })}
                                            placeholder="Empleado"
                                            style={{ width: 160 }}
                                        />
                                        <ButtonItem type="primary" size="small" onClick={() => this.emparejar(record.pin)}>
                                            OK
                                        </ButtonItem>
                                        <ButtonItem size="small" onClick={() => this.setState({ emparejarPin: null, emparejarEmpleadoId: null })}>
                                            X
                                        </ButtonItem>
                                    </Space>
                                ) : (
                                    <ButtonItem size="small" onClick={() => this.setState({ emparejarPin: record.pin, emparejarEmpleadoId: null })}>
                                        Emparejar
                                    </ButtonItem>
                                )
                            )}
                            <Popconfirm
                                title="¿Eliminar este usuario del reloj?"
                                onConfirm={() => this.eliminarDelReloj(record.pin)}
                                okText="Sí"
                                cancelText="No"
                            >
                                <ButtonItem danger size="small" icon={<DeleteOutlined />} />
                            </Popconfirm>
                        </Space>
                    );
                },
            },
        ];

        const columnasSistema = [
            { title: "PIN", dataIndex: "usuarioRelojChecador", key: "usuarioRelojChecador", width: 70 },
            { title: "Empleado", dataIndex: "empleadoNombre", key: "empleadoNombre" },
            { title: "Huella", dataIndex: "tieneHuella", key: "tieneHuella", align: "center", width: 80, render: tagSiNo },
            { title: "Rostro", dataIndex: "tieneRostro", key: "tieneRostro", align: "center", width: 80, render: tagSiNo },
            {
                title: "Estado",
                key: "estado",
                width: 160,
                render: (_, record) => {
                    const enReloj = usuariosDispositivo.some((u) => u.pin === record.usuarioRelojChecador);
                    return enReloj
                        ? <Tag color="green">En el reloj</Tag>
                        : <Tag color="red">No encontrado en el reloj</Tag>;
                },
            },
            {
                title: "Acción",
                key: "accion",
                width: 80,
                render: (_, record) => (
                    <Popconfirm
                        title="¿Eliminar esta asignación del sistema?"
                        onConfirm={() => this.eliminarDelSistema(record.asignacionRelojId)}
                        okText="Sí"
                        cancelText="No"
                    >
                        <ButtonItem danger size="small" icon={<DeleteOutlined />} />
                    </Popconfirm>
                ),
            },
        ];

        return (
            <ModalItem
                title={
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingRight: 24 }}>
                        <span>Información del reloj{data?.nombre ? `: ${data.nombre}` : ""}</span>
                        <ButtonItem size="small" icon={<ReloadOutlined />} onClick={this.actualizarAhora.bind(this)}>
                            Actualizar ahora
                        </ButtonItem>
                    </div>
                }
                visible={this.props.visible}
                spinning={this.state.loading}
                onCancel={this.cerrar.bind(this)}
                width="90%"
                paddingTop
            >
                {data && (
                    <div style={{ marginBottom: 12, fontSize: 12, color: "#666" }}>
                        {data.deviceName && <span style={{ marginRight: 12 }}>Dispositivo: {data.deviceName}</span>}
                        {data.versionFirmware && <span style={{ marginRight: 12 }}>Firmware: {data.versionFirmware}</span>}
                        {data.ipLocal && <span style={{ marginRight: 12 }}>IP: {data.ipLocal}</span>}
                        {data.ultimaConexionAt && (
                            <span style={{ marginRight: 12 }}>
                                Última conexión: {moment(data.ultimaConexionAt).fromNow()}
                            </span>
                        )}
                        {esperandoRespuesta && (
                            <Tag color="processing">Esperando respuesta del reloj…</Tag>
                        )}
                    </div>
                )}
                <Row gutter={16}>
                    <Col xs={24} md={12}>
                        <h4>En el reloj</h4>
                        <TableItem
                            size="small"
                            rowKey="pin"
                            columns={columnasDispositivo}
                            dataSource={usuariosDispositivo}
                            scroll={{ x: "max-content" }}
                        />
                    </Col>
                    <Col xs={24} md={12}>
                        <h4>En el sistema</h4>
                        <TableItem
                            size="small"
                            rowKey="asignacionRelojId"
                            columns={columnasSistema}
                            dataSource={asignaciones}
                            scroll={{ x: "max-content" }}
                        />
                    </Col>
                </Row>
            </ModalItem>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(InformacionRelojChecador);
